module.exports = __webpack_public_path__ + "static/media/gardening.5e50767e.png";